import { useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import { GQLMutation } from "@rx-cs-system/schema";

import { DeliveryOrderFragments } from "./queries";

/**
 * Order Delivery
 */
export const CREATE_ORDER_DELIVERY = gql`
  mutation createDeliveryOrder($input: CreateDeliveryOrderInput!) {
    createDeliveryOrder(input: $input) {
      ...DeliveryOrderDetails
    }
  }
  ${DeliveryOrderFragments.details}
`;

/**
 * Reissue Secret Code
 */
export const REISSUE_SECRET_CODE = gql`
  mutation reissueSecretCode($medicalInstitutionMemberId: ID!) {
    reissueSecretCode(medicalInstitutionMemberId: $medicalInstitutionMemberId) {
      secretCode
    }
  }
`;

export const ReissueSecretCodeMutation = (
  baseOptions?: useMutation.Options<GQLMutation>,
) => useMutation<GQLMutation>(REISSUE_SECRET_CODE, baseOptions);

/**
 * Resend Welcome Mail
 */

export const RESEND_WELCOME_MAIL = gql`
  mutation resendWelcomeMail($input: ResendWelcomeMailInput!) {
    resendWelcomeMail(input: $input) {
      ... on ResendWelcomeMailSuccess {
        contract {
          id
          manager {
            id
            name
            emailAddress
          }
        }
        resendEmailAddress
      }
      ... on ResendWelcomeMailFailure {
        message
      }
    }
  }
`;

export const RESEND_WELCOME_MAIL_V2 = gql`
  mutation resendWelcomeMailV2($input: ResendWelcomeMailV2Input!) {
    resendWelcomeMailV2(input: $input) {
      ... on ResendWelcomeMailV2Success {
        contract {
          id
          responsiblePerson {
            id
            emailContact {
              id
              name
              emailAddress
              department
            }
          }
        }
        resendEmailAddress
      }
      ... on ResendWelcomeMailV2Failure {
        message
      }
    }
  }
`;

export const CREATE_PDT_DOCUMENT = gql`
  mutation createPdtDocument($input: CreatePdtDocumentInput!) {
    createPdtDocument(input: $input) {
      id
      name
    }
  }
`;

/**
 * PDT資材をストレージにアップロードしてからpdtDocumentを作成する
 */
export const UPLOAD_PDT_DOCUMENT = gql`
  mutation uploadPdtDocument($input: UploadPdtDocumentInput!) {
    uploadPdtDocument(input: $input) {
      id
      name
      url
    }
  }
`;

/**
 * HT患者のメールアドレスを更新する
 */
export const UPDATE_HT_USER_EMAIL_ADDRESS = gql`
  mutation updateHtUserEmailAddress($input: UpdateHtUserEmailAddressInput!) {
    updateHtUserEmailAddress(input: $input) {
      id
      prescriptionCode
      prescribedAt
      status
      nickname
      appName
      pdtCode
      pdtId
      birthday
      medicalInstitutionId
      medicalInstitutionName
      email
      createdAt
      bloodPressureMeasurementRate
    }
  }
`;

/**
 * HT患者のパスワードを更新する
 */
export const UPDATE_HT_USER_PASSWORD = gql`
  mutation updateHtUserPassword($input: UpdateHtUserPasswordInput!) {
    updateHtUserPassword(input: $input) {
      id
    }
  }
`;

/**
 * HT患者の確認番号を発行する
 */
export const PUBLISH_HT_VERIFY_CODE = gql`
  mutation publishHtVerifyCode($input: VerifyCodeInput!) {
    publishHtVerifyCode(input: $input) {
      code
      permanent
    }
  }
`;

/**
 * Cancel Contract
 */
export const CANCEL_CONTRACT_MUTATION = gql`
  mutation CancelContract($input: CancelContractInput!) {
    cancelContract(input: $input) {
      contract {
        id
        deletedAt
      }
    }
  }
`;

/**
 * Cancel Medical Institution (退会)
 */
export const CANCEL_MEDICAL_INSTITUTION_MUTATION = gql`
  mutation CancelMedicalInstitution($input: CancelMedicalInstitutionInput!) {
    cancelMedicalInstitution(input: $input) {
      ... on CancelMedicalInstitutionSuccess {
        medicalInstitution {
          id
          name
          deletedAt
        }
      }
      ... on ActiveContractExistsError {
        code
        message
        medicalInstitutionId
        activeContractCount
      }
    }
  }
`;

export const FORCE_CANCEL_PRESCRIPTION = gql`
  mutation forceCancelPrescription($input: ForceCancelPrescriptionInput!) {
    forceCancelPrescription(input: $input) {
      ... on ForceCancelPrescriptionError {
        message
        code
        prescriptionCode
      }
      ... on Prescription {
        id
        prescriptionCureAppPdtCode {
          id
          status
        }
      }
    }
  }
`;

/**
 * Notifications
 */
export const CREATE_CS_NOTIFICATION = gql`
  mutation CreateCsNotification($input: CreateCsNotificationInput!) {
    createCsNotification(input: $input) {
      id
      title
    }
  }
`;

export const UPDATE_CS_NOTIFICATION = gql`
  mutation UpdateCsNotification($input: UpdateCsNotificationInput!) {
    updateCsNotification(input: $input) {
      id
      title
    }
  }
`;

export const DELETE_CS_NOTIFICATION = gql`
  mutation DeleteCsNotification($id: ID!) {
    deleteCsNotification(id: $id) {
      ... on DeleteCsNotificationSuccess {
        id
      }
      ... on DeleteCsNotificationError {
        code
        message
      }
    }
  }
`;

export const CREATE_CS_NOTIFICATION_IMAGE_UPLOAD_URL = gql`
  mutation CreateCsNotificationImageUploadUrl(
    $input: CreateCsNotificationImageUploadUrlInput!
  ) {
    createCsNotificationImageUploadUrl(input: $input) {
      ... on CsNotificationImageUploadUrl {
        url
        fields
        key
      }
      ... on CsNotificationImageUploadUrlError {
        code
        message
      }
    }
  }
`;
